import OfflineModeHeader from './OfflineModeHeader';

export default OfflineModeHeader;
